function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Checkbox from "./Checkbox.js";
import Popper from "./popper/Popper.js";
import "./HierarchicalCheckboxMenu.css";
import Button from "./Button.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A pull down menu that displays a hierarchy of checkboxes.
 *
 * Currently supports only two levels of check boxes. The input should be a Map
 * where the keys are the parent names. The values can a boolean if the parent
 * has no children or another Map where keys are child names and values are booleans.
 *
 * Here is an example:
 * const INITIAL_TYPE_MAP = new Map([
 * ['Queries', new Map([['Live', true], ['Batch', true]])],
 * [
 *   'DBA Queries',
 *   new Map([
 *     ['Data Merge', true],
 *     ['Data Validation', true],
 *     ['Imports', true],
 *     ['Data Services', true],
 *   ]),
 * ],
 * ['Helper Queries', true],
 * ]);
 *
 * When a checkbox is changed, this component will make a deep copy of the Map
 * with the appropriate booleans changed. It will then call onUpdateValueMap
 * with the new Map.
 */
class HierarchicalCheckboxMenu extends Component {
  static isParentSelected(parent, valueMap) {
    var children = valueMap.get(parent);
    if (children === undefined) {
      return false;
    }
    if (typeof children === 'boolean') {
      // This parent has no children
      return children;
    }
    var includesTrue = Array.from(children.values()).includes(true);
    var includesFalse = Array.from(children.values()).includes(false);
    if (includesTrue && includesFalse) {
      // Indeterminate
      return null;
    }
    return includesTrue;
  }
  constructor(props) {
    super(props);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleValueFor = this.toggleValueFor.bind(this);
    this.selectAll = this.selectAll.bind(this);
    this.clear = this.clear.bind(this);
    this.state = {
      menuIsOpen: false
    };
  }
  toggleMenu(event) {
    event.stopPropagation();
    event.preventDefault();
    this.setState(state => {
      var menuIsOpen = state.menuIsOpen;
      return {
        menuIsOpen: !menuIsOpen
      };
    });
  }
  toggleValueFor(parent, child) {
    var _this$props = this.props,
      valueMap = _this$props.valueMap,
      onUpdateValueMap = _this$props.onUpdateValueMap;

    // Make a deep copy of the Map and toggle the boolean for parent / child
    var map = new Map(valueMap);
    var children = map.get(parent);
    if (children instanceof Map) {
      var newChildren = new Map(children);
      if (child != null) {
        newChildren.set(child, children.get(child) !== true);
      } else {
        var parentSelected = HierarchicalCheckboxMenu.isParentSelected(parent, map);
        var newChildValue = parentSelected == null || !parentSelected;
        children.forEach((_, key) => newChildren.set(key, newChildValue));
      }
      map.set(parent, newChildren);
    } else {
      map.set(parent, children == null || !children);
    }

    // The parent was clicked so all children must be toggled
    var currentChildren = map.get(parent);
    if (child === undefined && currentChildren !== undefined && typeof currentChildren !== 'boolean') {
      var _parentSelected = HierarchicalCheckboxMenu.isParentSelected(parent, valueMap);
      if (_parentSelected != null && _parentSelected) {
        currentChildren.forEach((_, key) => currentChildren.set(key, false));
      } else {
        // for parent selection of false or null (indeterminate), select everything
        currentChildren.forEach((_, key) => currentChildren.set(key, true));
      }
    }
    onUpdateValueMap(map);
  }
  setAllValues(value) {
    var _this$props2 = this.props,
      valueMap = _this$props2.valueMap,
      onUpdateValueMap = _this$props2.onUpdateValueMap;

    // Make a deep copy of the Map and set everything
    var copy = new Map();
    valueMap.forEach((child, parent) => {
      if (typeof child === 'boolean') {
        copy.set(parent, value);
      } else {
        var children = new Map();
        child.forEach((_, key) => children.set(key, value));
        copy.set(parent, children);
      }
    });
    onUpdateValueMap(copy);
  }
  selectAll() {
    this.setAllValues(true);
  }
  clear() {
    this.setAllValues(false);
  }
  renderMenuElement() {
    var _this$props3 = this.props,
      valueMap = _this$props3.valueMap,
      dataTestId = _this$props3['data-testid'];
    return /*#__PURE__*/_jsxs("div", {
      className: "hcm-menu-container",
      children: [Array.from(valueMap.entries()).map(_ref => {
        var _ref2 = _slicedToArray(_ref, 2),
          parent = _ref2[0],
          children = _ref2[1];
        return /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Checkbox, {
            className: "hcm-parent",
            checked: HierarchicalCheckboxMenu.isParentSelected(parent, valueMap),
            onChange: () => this.toggleValueFor(parent),
            children: parent
          }), children !== undefined && typeof children !== 'boolean' && Array.from(children.entries()).map(_ref3 => {
            var _ref4 = _slicedToArray(_ref3, 2),
              child = _ref4[0],
              value = _ref4[1];
            return /*#__PURE__*/_jsx(Checkbox, {
              className: "hcm-child",
              checked: value,
              onChange: () => this.toggleValueFor(parent, child),
              children: child
            }, child);
          })]
        }, parent);
      }), /*#__PURE__*/_jsx(Button, {
        kind: "ghost",
        onClick: this.selectAll,
        "data-testid": dataTestId !== undefined ? "".concat(dataTestId, "-btn-select-all") : undefined,
        children: "Select All"
      }), /*#__PURE__*/_jsx(Button, {
        kind: "ghost",
        onClick: this.clear,
        "data-testid": dataTestId !== undefined ? "".concat(dataTestId, "-btn-clear") : undefined,
        children: "Clear"
      })]
    });
  }
  render() {
    var _this$props4 = this.props,
      menuText = _this$props4.menuText,
      className = _this$props4.className,
      icon = _this$props4.icon,
      id = _this$props4.id,
      dataTestId = _this$props4['data-testid'];
    var menuIsOpen = this.state.menuIsOpen;
    return /*#__PURE__*/_jsxs("button", {
      type: "button",
      className: classNames('btn hcm-btn', className),
      onClick: this.toggleMenu,
      id: id,
      "data-testid": dataTestId,
      children: [/*#__PURE__*/_jsxs("span", {
        children: [icon && /*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: icon,
          className: "hcm-icon mr-1"
        }), menuText]
      }), /*#__PURE__*/_jsx("span", {
        className: "cs-caret"
      }), /*#__PURE__*/_jsx(Popper, {
        options: {
          placement: 'bottom'
        },
        isShown: menuIsOpen,
        onExited: () => {
          this.setState({
            menuIsOpen: false
          });
        },
        closeOnBlur: true,
        interactive: true,
        children: this.renderMenuElement()
      })]
    });
  }
}
_defineProperty(HierarchicalCheckboxMenu, "defaultProps", {
  className: '',
  icon: null,
  id: '',
  'data-testid': undefined
});
export default HierarchicalCheckboxMenu;
//# sourceMappingURL=HierarchicalCheckboxMenu.js.map